module.exports = __webpack_public_path__ + "static/flags/TR-d36d068675ad82ed3fb71dd095d1f1a1.gif";